module.exports = __webpack_public_path__ + "img/base_divers_bulle.380e95f8.svg";